import * as types from './types'
import { createReducer } from '../../utils'

const showReducer = createReducer({})({
	[types.SHOW_NOTIFICATION]: (state, action) => action.payload,
	[types.HIDE_NOTIFICATION]: (state) => (state = {}),
})

export default showReducer
